import { fork } from 'redux-saga/effects';

import * as organizations from './requests/organizations-req';
import * as locations from './requests/locations-req';
import * as payments from './requests/payments-req';
import * as deleteCard from './requests/delete-card-req';

import { refetchPaymentMethods } from './sagas/refetch-payment-methods';

export default function* paymentMethodsRootSaga() {
  yield fork(organizations.watcher);
  yield fork(locations.watcher);
  yield fork(payments.watcher);
  yield fork(deleteCard.watcher);

  yield fork(refetchPaymentMethods);
}



// WEBPACK FOOTER //
// ./src/redux/payment-methods/root-saga.js